import { render, staticRenderFns } from "./AppReviewMediaSectionListV3.vue?vue&type=template&id=15553491&scoped=true"
import script from "./AppReviewMediaSectionListV3.vue?vue&type=script&lang=js"
export * from "./AppReviewMediaSectionListV3.vue?vue&type=script&lang=js"
import style0 from "./AppReviewMediaSectionListV3.vue?vue&type=style&index=0&id=15553491&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15553491",
  null
  
)

export default component.exports